var _image;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEngtemp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    enableBackground: "new 0 0 20 20",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAABSlBMVEUAAADsLDXsLDXsLDXs LDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXs LDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXs LDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXs LDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXs LDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXs LDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXsLDXsLDX////4RqJiAAAAbHRSTlMAAAYnEWPkoQqf3hue 3R0B87KrYu2HekbcGvS0ruyEdkQgBAP2xcFu6W1dNafiIj7qjiw7DHXMFT0rCJjW0eDLnPGp0OGT XE0kOm9TYLyZNyFKVQUCPIXEzZpZVpHKVFqbw4aje7C5gN+vDx4GMp5QAAAAAWJLR0RtuwYArQAA AAlwSFlzAAALEgAACxIB0t1+/AAAAAd0SU1FB+MHDxMnOrTueTQAAADrSURBVBjTY2AAA0ZGJmYW RkYGFMDIyMrGzoEhyJnDxc3IiKKYkZEnh5ePkR9DUEBQSBhDUERUTBxDUEISi5lS0jKsGIKycvIK mLYrKiljCKqoqqljCGpoammjCirr5OjqwW1nhAB9g5wcQ34oh4GRw4hV09jENCcnx8ycxUJd2BIY LlbWuja2dvYOjjk5gk62ds42Lq5MDExu7h56nl7ePr5+2uqa/gEegUHBDCGhYeERkVHRMRGxMXHx CRGJSfrKDFbJqqIpqRJcaenpaRkSmWKiqjocDCF8WcC48GDmYGTkYPZgYmTMyg4BACq6Jqplapnl AAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE5LTA3LTE1VDE5OjM5OjU4KzAzOjAwdQTJqQAAACV0RVh0 ZGF0ZTptb2RpZnkAMjAxOS0wNy0xNVQxOTozOTo1OCswMzowMARZcRUAAAAASUVORK5CYII="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngtemp);
export default __webpack_public_path__ + "static/media/engtemp.9e0fbbb14daddcd5c7cf797859244702.svg";
export { ForwardRef as ReactComponent };